import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';

// Подписи — дескрипторы: переводятся на месте показа, `t(option.label)`.
// Порядок — «Активный» первым: прежний `STATUS_OPTIONS.reverse()` переворачивал этот массив
// на месте, и именно такой порядок видели оба селекта.
export const STATUS_OPTIONS: { value: boolean; label: MessageDescriptor }[] = [
  {
    value: true,
    label: msg`Активный`,
  },
  {
    value: false,
    label: msg`Неактивный`,
  },
];

export const STATUS_FILTER_OPTIONS: { value: boolean | null; label: MessageDescriptor }[] = [
  {
    value: null,
    label: msg`Все`,
  },
  ...STATUS_OPTIONS,
];
